<template>
            <div class="title" id="explore">Explore</div>

</template>
<script>
    export default {
        name : 'NavBar'
    }
</script>